import Tiers from './tiers'

// import middlewares
export default [{
  path: '/tiers/:id',
  component: Tiers,
  name: 'Tiers',
  meta: {
    nav: {
      display: false,
      name: 'Tier'
    }
  }
}]
